"use strict";

const app = angular.module('rmDashboard');

const dashboardTemplate = `
<default-dashboard ng-if="dashboardSettings.dashboard==='default'"></default-dashboard>
<time-table-dashboard ng-if="dashboardSettings.dashboard==='time_table'"></time-table-dashboard>
`;

app.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('dashboard', {
            url: "/dashboard",
            views: {
                dashboard: {
                    template: dashboardTemplate,
                    controller: 'DashboardCtrl',
                    controllerAs: 'ctrl',
                },
            },

            onEnter: ['bladesManager', function (bladesManager) {
                bladesManager.clearAll();
                bladesManager.insert({viewName: 'dashboard', size: 'full'});
            }]
        });
}]);
